@if (maintenanceService.isActive()) {
    <app-maintenance />
} @else {
    <router-outlet></router-outlet>
}
